



















import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { VaultFile } from "@scrile/api-provider/dist/api/VaultsProvider";
import BaseIcon from "@/components/BaseIcon";
import InfiniteScroll from "@/components/InfiniteScroll";
import { UsedFilesMap } from "../../types";
import VaultFiles from "../VaultFiles";

const CHECKED_FILE_CLASSES = "vault-file-list__file __checked";

export default defineComponent({
  name: "VaultFilesList",
  components: { InfiniteScroll, BaseIcon, VaultFiles },
  props: {
    vaultFiles: { type: Array as () => VaultFile[], required: true },
    usedFilesMap: { type: Object as () => UsedFilesMap },
    scroll: { type: Boolean, default: false },
    maxFiles: { type: Number, default: 1 },
  },
  setup(props, { emit }) {
    const checkedFiles = ref<Record<string, boolean | undefined>>({});

    const fileClasses = computed(() => {
      return Object.fromEntries(Object.entries(checkedFiles.value).map(i => [i[0], i[1] ? CHECKED_FILE_CLASSES : ""]));
    });
    const emptySelection = computed(() => Object.values(checkedFiles.value).every(i => !i));

    const checkedFileList = computed(() => props.vaultFiles.filter(f => checkedFiles.value[f.id]));
    const onToggle = (id: string) => {
      if (!checkedFiles.value[id] && checkedFileList.value.length >= props.maxFiles) return;

      checkedFiles.value = {
        ...checkedFiles.value,
        [id]: !checkedFiles.value[id],
      };
    };

    const isChecked = (id: string) => !!checkedFiles.value[id];

    const onFileCheck = (file: VaultFile) => {
      if (props.maxFiles > 1) {
        onToggle(file.id);
        emit("input", checkedFileList.value);
      } else {
        emit("submit", [file]);
      }
    };

    emit("onClear", () => {
      checkedFiles.value = {};
      emit("input", checkedFileList.value);
    });

    watch(emptySelection, emptySelection => emit("hasSelection", !emptySelection), { immediate: true });

    return {
      isChecked,
      onFileCheck,
      fileClasses,
    };
  },
});
